interface IOfferCard {
  date: string;
  image: string;
  percentage: string;
  coupon: string;
  description: string;
}

export const OfferCard: React.FC<IOfferCard> = ({
  date,
  image,
  percentage,
  description,
}) => {
  return (
    <div className="w-80 lg:w-[48%] mr-12 lg:mr-3 md:w-[48%] sm:w-full my-3 md:mr-3 sm:mr-0 last:mr-0">
      <div
        style={{
          border: '0.981px solid #FFE3CA',
          background: 'linear-gradient(35deg, #FFEACC 0%, #FFFAF3 100%)',
        }}
        className="rounded-xl m-0 p-6 relative w-full sm:my-3"
      >
        <div
          style={{
            border: '0.981px solid #5A925F',
            background: 'linear-gradient(21deg, #4BA842 20.11%, #B5FFBC 100%)',
          }}
          className="absolute flex items-center justify-center text-white py-1.5 px-4 h-8 rounded-sm -top-4"
        >
          <p className="text-white font-bold text-base">{date}</p>
        </div>
        <p className="text-font-200 text-s-10 mt-3">Powered by</p>
        <img
          src={image}
          width={69}
          height={69}
          alt="logo"
          className="object-contain"
        ></img>
        <p
          style={{
            borderTop: '0.981px solid #FFE3CA',
          }}
          className="text-base text-[#383838] pt-4 mt-6 px-6 -mx-6 xl:h-20"
        >
          {description}
        </p>

        <div className="absolute top-2 right-4 text-center z-10">
          <p className="text-white text-base font-extrabold leading-tight">
            {'Upto'}
          </p>
          <p className="text-white text-s-32 font-extrabold leading-none">
            {percentage}
          </p>
          <p className="text-white text-base font-extrabold leading-tight">
            {'OFF'}
          </p>
        </div>
        <img
          src={'https://assets.clear.in/cleartax/images/1688639662_star.svg'}
          className="absolute top-0 right-0 object-contain"
          alt={'star-icon'}
          width={105}
          height={103}
        ></img>
      </div>
    </div>
  );
};
